import 'slick-carousel/slick/slick';

export default {
  init() {
    // JavaScript to be fired on the locals archive

    //console.log('hi Su');

    $('.syncingSlider--single').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  prev"><i class="icon-arrow-left2"></i></button>',
      nextArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  next"><i class="icon-arrow-right2"></i></button>',
      arrows: false,
      fade: true,
      asNavFor: '.syncingSlider--nav',
    });
    $('.syncingSlider--nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  prev"><i class="icon-arrow-left2"></i></button>',
      nextArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  next"><i class="icon-arrow-right2"></i></button>',
      asNavFor: '.syncingSlider--single',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
    });
   
  },
};



// WEBPACK FOOTER //
// ./scripts/library/library-slick.js